import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/layouts/AdminLayout';
import DashboardOverviewAA from './admissions-admin/DashboardOverview';
import InputTestResults from './admissions-admin/InputTestResults';
import ViewApplicants from './admissions-admin/ViewApplicants';
import '../styles/dashboard.css';
import './admissions-admin/AdmissionsAdminDashboard.css';

function AdmissionsAdminDashboard({ user, onLogout, apiBase }) {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({
    totalApplicants: 0,
    byLevel: {},
    byLocation: {},
    testPending: 0,
    testCompleted: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      // Fetch applicant statistics
      const response = await fetch(`${apiBase}/admissions/applicants?limit=1`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      if (data.ok && data.data) {
        setStats(prev => ({
          ...prev,
          totalApplicants: data.data.pagination?.total || 0
        }));
      }
    } catch (err) {
      console.error('Error loading stats:', err);
    }
  };

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
          <polyline points="12 12 20 7.5" />
          <polyline points="12 12 12 21" />
          <polyline points="12 12 4 7.5" />
        </svg>
      )
    },
    {
      id: 'input-test',
      label: 'Input Hasil Test',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      )
    },
    {
      id: 'view-applicants',
      label: 'Lihat Pendaftar',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    }
  ];

  const roleColor = '#0ea5e9';
  const dashboardTitle = 'Admissions Admin';

  return (
    <AdminLayout
      user={user}
      onLogout={onLogout}
      roleColor={roleColor}
      dashboardTitle={dashboardTitle}
      menuItems={menuItems}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      <div className="dashboard-content">
        {activeTab === 'dashboard' && (
          <DashboardOverviewAA apiBase={apiBase} stats={stats} onRefresh={loadStats} />
        )}

        {activeTab === 'input-test' && (
          <InputTestResults apiBase={apiBase} roleColor={roleColor} />
        )}

        {activeTab === 'view-applicants' && (
          <ViewApplicants apiBase={apiBase} roleColor={roleColor} />
        )}
      </div>
    </AdminLayout>
  );
}

export default AdmissionsAdminDashboard;
